import hasClipboardExternalLink from './has-clipboard-external-link';

export default {
  hasClipboardExternalLink,
};
